import { QBS_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { QBSLevelCheckboxGroup } from '@exam-management/components';
import type { QBankStructureLevelCategory } from '@exam-management/graphql';
import type { QBankStructureLevel } from '@exam-management/qbs-provider';
import { Button, DialogActions, DialogContent, Form, Text } from '@shared/components';
import { FormProvider, useForm } from 'react-hook-form';

interface SetupQBankStructureFormProps {
  qBankStructureLevels: QBankStructureLevel[];
  onSetupLevelSubmit: (formValues: QBankStructureLevel[]) => Promise<void>;
  onClose: () => void;
  loading: boolean;
}

type QBankStructureLevelStatusByCategory = {
  [key in QBankStructureLevelCategory]: boolean;
};

export default function SetupQBankStructureLevelForm(
  props: Readonly<SetupQBankStructureFormProps>,
) {
  const { qBankStructureLevels, onClose, onSetupLevelSubmit, loading: isLoading } = props;

  const formContext = useForm<QBankStructureLevelStatusByCategory>({
    defaultValues: qBankStructureLevels.reduce((acc, { category, enabled }) => {
      acc[category] = enabled;
      return acc;
    }, {} as QBankStructureLevelStatusByCategory),
  });

  const onSubmit = (data: QBankStructureLevelStatusByCategory) => {
    const updatedQBankStructureLevels = qBankStructureLevels.map((level) => ({
      ...level,
      enabled: data[level.category] ?? true,
    }));
    onSetupLevelSubmit(updatedQBankStructureLevels);
  };

  const handleSubmit = formContext.handleSubmit(onSubmit);

  return (
    <FormProvider {...formContext}>
      <Form onSubmit={handleSubmit}>
        <DialogContent
          sx={{
            pt: (theme) => theme.spacing(4),
          }}
        >
          <Text
            sx={{
              mb: (theme) => theme.spacing(4),
            }}
          >
            เลือกเลเวลที่ต้องการใช้งานในคลังข้อสอบ
          </Text>
          <QBSLevelCheckboxGroup qBankStructureLevels={qBankStructureLevels} />
        </DialogContent>
        <DialogActions
          sx={(theme) => ({
            pt: theme.spacing(5),
            borderTop: '1px solid',
            borderTopColor: theme.palette.divider,
          })}
        >
          <Button
            type='submit'
            onClick={onClose}
            fullWidth
            loading={isLoading}
            data-testid={QBS_DATA_TEST_ID.SETUP_LEVEL_FORM_SUBMIT_BUTTON}
            size='large'
          >
            เริ่มสร้างโครงสร้าง
          </Button>
        </DialogActions>
      </Form>
    </FormProvider>
  );
}
